export class FetchRegions {
  static readonly type = '[Regions] Fetch Regions';
}
